































































































































































































































































































































































import { Mixins, Component, Emit } from 'vue-property-decorator';
import { TokenStatus } from '@/api';
import { AxStorage } from '@/storage';
import { AxPage } from '@/mixins';
import moment from 'moment';
import router from '@/router';
import * as I from '@/interfaces';
import * as mdi from '@mdi/js';

type AxIcons = { [name: string]: string };

class AxFrameError extends Error {
  __proto__: Error;
  constructor(message?: string) {
    const trueProto = new.target.prototype;
    super(message);

    this.__proto__ = trueProto;
  }
}

class AxFrameNavigateFailed extends AxFrameError {
  constructor(message?: string) {
    super(message);
  }
}

interface MenuIndex {
  group: number;
  menu: number;
}

@Component
export default class extends Mixins(AxPage) {
  hoverTimeBox = false;
  dialog = false;
  skipLogin = false;

  selected: MenuIndex = {
    group: -1,
    menu: -1
  };

  activated: MenuIndex = {
    group: -1,
    menu: -1
  };

  timeBox: I.AxTimeBox = {
    month: 'JAN',
    day: '1',
    hour: '0',
    minute: '0'
  };

  sessionTime: I.AxSessionTime = {
    hour: '0',
    minute: '0'
  };

  listMenu: I.AxMenu[] = [];
  listChildMenu: I.AxMenu[] = [];
  listPrevChildMenu: I.AxMenu[] = [];

  icons: AxIcons = {
    USER: mdi.mdiAccount,
    AUTH: mdi.mdiSecurity,
    TEMP: mdi.mdiClipboardAccount,
    CONFIG: mdi.mdiCog,
    EXCEL: mdi.mdiMicrosoftExcel,
    EVENT: mdi.mdiAlertCircleCheck,
    MONITOR: mdi.mdiMonitorDashboard,
    MEAL: mdi.mdiSilverwareVariant,
    ATTENDANCE: mdi.mdiAccountClock,
    VISITOR: mdi.mdiAccountSupervisor,
    OTHERS: mdi.mdiInformation
  };

  get currentGroup() {
    return this.listMenu[this.activated.group];
  }

  get currentMenu() {
    return this.listPrevChildMenu[this.activated.menu];
  }

  isDevPage() {
    return router.currentRoute.path === '/AxDev';
  }

  setLatestInfo(info: I.AxLatestInfo) {
    console.log('setLatestInfo:' + info.groupId);
    console.log('setLatestInfo:' + info.action);
    AxStorage.latestInfo = info;
    this.latestInfo.controller = info.controller;
    this.latestInfo.action = info.action;
    this.latestInfo.groupId = info.groupId;
  }

  async navigate({ controller, action, groupId }: I.AxNavigate) {
    let target = '';
    console.log('모니터그룹:' + controller + '/' + action + '/' + groupId);
    if (controller && controller.length > 0) {
      target = `/${controller}/${action}`;
    } else if (action && action.length > 0) {
      target = `/${action}`;
    } else {
      throw new AxFrameNavigateFailed(JSON.stringify({ controller, action }));
    }

    if (target !== router.currentRoute.path) {
      try {
        console.log('target' + target);
        await router.replace(target);
      } catch {}
    } else {
      console.log('target2' + target + 'con:' + controller + 'id:' + groupId);
      //await router.replace('/AxHome');
      //await router.replace(target);
      console.log('target_go' + target);
      await router.go(0);
    }
  }

  async created() {
    this.updateTime();

    if (this.isDevelopment) {
      await this.initDev();
    } else {
      await this.initProd();
    }

    await this.postInit();
  }

  async initDev() {
    const loginData = this.getLoginData();
    this.listMenu = loginData.listMenu;
    this.skipLogin = AxStorage.skipLogin || false;
  }

  async initProd() {
    const loginData = this.getLoginData();
    this.listMenu = loginData.listMenu;
  }

  async postInit() {
    const info = AxStorage.latestInfo;
    console.log('post:' + info?.groupId);
    if (info) {
      this.setLatestInfo(info);

      if (info.controller.length > 0) {
        const groupMenu = this.listMenu.find(x => x.controllerName === info.controller);
        if (!groupMenu) {
          this.onHomeClicked();
          return;
        }

        const childMenu = groupMenu.listChildMenu.find(x => x.actionName === info.action);
        if (!childMenu) {
          this.onHomeClicked();
          return;
        }

        const groupMenuIdx = this.listMenu.indexOf(groupMenu);
        const childMenuIdx = groupMenu.listChildMenu.indexOf(childMenu);

        this.onGroupMenuChanged(groupMenu, groupMenuIdx);
        this.onChildMenuChanged(childMenu, childMenuIdx);
      }

      this.navigate(this.latestInfo);
    } else {
      this.onHomeClicked();
    }
  }

  mounted() {
    setInterval(() => this.updateTime(), 1000);
    setTimeout(() => this.validateToken(), 1000);
  }

  updateTime() {
    moment.locale('en');
    const now = moment(Date.now());
    this.timeBox = {
      month: now.format('MMM'),
      day: now.format('D'),
      hour: now.format('HH'),
      minute: now.format('mm')
    };

    const tokenInfo = this.API.fetchTokenInfo();
    if (tokenInfo) {
      const now = moment(Date.now());
      const exp = moment(tokenInfo.payload.exp * 1000);
      const expDuration = moment.duration(exp.diff(now));

      this.sessionTime = {
        hour: expDuration
          .hours()
          .toString()
          .padStart(2, '0'),
        minute: expDuration
          .minutes()
          .toString()
          .padStart(2, '0')
      };
    }
  }

  OnClickMap(e: Event) {
    console.log(e);
    this.navigate({
      controller: 'MONITOR',
      action: 'MonitoringMap',
      groupId: e.groupId
    });
  }

  OnClickGrid(e: Event) {
    console.log(e);
    this.navigate({
      controller: 'MONITOR',
      action: 'Monitoring',
      groupId: e.groupId
    });
  }

  OnClickMonitorGroup(e: Event) {
    console.log(e);
    this.navigate({
      controller: 'MONITOR',
      action: 'MonitorGroup',
      groupId: e.groupId
    });
  }

  async validateToken() {
    const status = await this.API.validateToken();

    if (status === TokenStatus.Ok) {
      setTimeout(() => this.validateToken(), 1000);
    } else {
      await this.handleTokenError(status);
    }
  }

  @Emit()
  async onGroupMenuChanged(menu: I.AxMenu, idx: number) {
    await this.$nextTick();

    this.listChildMenu = menu.listChildMenu;
    this.selected.group = idx;
    this.selected.menu = this.selected.group === this.activated.group ? this.activated.menu : -1;
  }

  @Emit()
  async onChildMenuChanged(child: I.AxMenu, idx: number) {
    await this.$nextTick();

    this.listPrevChildMenu = this.listChildMenu;
    const controller = child.controllerName;
    const action = child.actionName;
    const mgroupid = child.monitorGroupID;
    console.log('child' + child.monitorGroupID);
    if (controller && action) {
      console.log('child' + mgroupid);
      //this.setLatestInfo({ controller, action, mgroupid });
      this.latestInfo.action = action;
      this.latestInfo.controller = controller;
      this.latestInfo.groupId = mgroupid;
      this.navigate(this.latestInfo);
    }

    await this.$nextTick();
    this.selected.menu = idx;
    this.activated.group = this.selected.group;
    this.activated.menu = this.selected.menu;
  }

  @Emit()
  onHomeClicked() {
    this.listChildMenu = [];
    this.listPrevChildMenu = [];

    this.selected.group = -1;
    this.selected.menu = -1;

    this.activated.group = -1;
    this.activated.menu = -1;

    this.setLatestInfo({ controller: '', action: 'AxHome', monitorGroupId: 0 });
    this.navigate(this.latestInfo);
  }

  @Emit()
  onSkipLoginClicked() {
    const b = !this.skipLogin;
    AxStorage.skipLogin = b;
    this.skipLogin = b;
  }

  @Emit()
  onDevPageClicked() {
    if (!this.isDevPage()) {
      this.navigate({ controller: '', action: 'AxDev', groupId: 0 });
    } else {
      this.navigate(this.latestInfo);
    }
  }

  async out() {
    const result = await this.API.call.logout();
  }

  async logout() {
    const result = await this.showConfirmModal('알림', '로그아웃 할까요?', ['네', '아니오']);
    if (result === 0) {
      this.out();
      this.userLogout();
    }
  }

  openVuetifyAPIExplorer() {
    window.open('https://vuetifyjs.com/en/components/api-explorer/');
  }
}
